import { ReferenceData } from './reference-data.model';

export const COMPENSATION_RATE_TYPE_HOURLY: string = 'Hourly';
export const COMPENSATION_RATE_TYPE_FLAT: string = 'Flat';
export const COMPENSATION_RATE_TYPE_HOURLY_PLUS_FLAT: string = 'HourlyPlusFlat';
export const COMPENSATION_RATE_TYPE_PERCENT: string = 'Percent';
export const COMPENSATION_RATE_TYPE_POINTS: string = 'Points';

export class CompensationRate extends ReferenceData {

  compensationRateType: string;
  frequencyId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.frequencyId = data.frequencyId;
    this.compensationRateType = data.compensationRateType;
  }
}
